import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=0208e28f&scoped=true&"
import script from "./NewProduct.vue?vue&type=script&lang=js&"
export * from "./NewProduct.vue?vue&type=script&lang=js&"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=0208e28f&prod&scoped=true&lang=css&"
import style1 from "./NewProduct.vue?vue&type=style&index=1&id=0208e28f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208e28f",
  null
  
)

export default component.exports